import { Box, Card, Grid, Stack, Typography } from '@mui/material'
import StatusText from 'common/component/StatusText'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import defaultProductImage from '../../../assets/images/placeholderproduct.svg';
import colors from 'assets/theme/base/colors';
import { getReorderDrag, getStaticLegal } from '../../../redux/slices/common';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Loader from 'common/Loader';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import NoDataFound from 'common/component/NoDataFound';

const PricingDetail = ({ legalId, fullRoleTabSlug }) => {
  const { grey } = colors;
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams();
  const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
  const { singleLegal, isLoading } = useSelector((state => state.common));
  const [dragSection, setDragSection] = useState(singleLegal?.topicSection?.section || []);
  const [nodataFound, setNodataFound] = useState(false)
  const fullRoleTabheading = useMemo(() => searchParams.get('heading'), [searchParams]);

  // ************************************************** Get Data **************************************************
  useEffect(() => {
    if (fullRoleTabheading) {
      dispatch(getStaticLegal({ id: fullRoleTabheading, platform: fullRoleTab })).unwrap().then((res) => {
        setDragSection(res?.legalDetails?.topicSection?.section)
        setNodataFound(false)

      }).catch((err) => {
        setNodataFound(true)

      });
    }
  }, [fullRoleTabheading, fullRoleTab])

  // Handle drag end
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(dragSection);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    const filteredData = items.map((item, index) => ({
      _id: item._id,
      order: index, // Reassign order based on position
    }));

    // ------------------------------------------api hit----------------------------------------------
    const payload = {
      "id": singleLegal?._id,
      "sectionType": "topicSection",
      sections: filteredData
    }
    dispatch(getReorderDrag(payload)).unwrap().then((res) => {
    }).catch((err) => {
    });
    // Update state to re-render the list
    setDragSection(items);
  };

  return (
    <>
      {
        isLoading ?
          <Loader /> :
          <>
            {
              nodataFound ? <NoDataFound /> :
                <Box p={4} pt={2} className="static-pages-container">

                  {/**************** Page Title ****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
                      <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>{fullRoleTabheading}</Typography>
                      <StatusText status={singleLegal?.status ? "active" : "inactive"} />
                    </Stack>
                  </Card>

                  {/***************** Selected Platforms ****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>

                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={2} mt={2}>
                      <Typography variant='h5' fontWeight="semibold">Visible On</Typography>
                    </Stack>

                    <Grid container alignItems="center" spacing={{ xs: 3, md: 4 }} mb={2}>
                      <Grid item xs={12}>
                        <Stack direction="row" alignItems="center" spacing={3}>
                          {singleLegal?.displaySettings?.footer && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Footer</badge>}
                          {singleLegal?.displaySettings?.hamburgerMenu && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Hamburger Menu</badge>}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Card>

                  {/***************** Meta Tags ****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">Meta Properties</Typography>
                    </Stack>

                    <Grid container alignItems="center" spacing={3} mb={2}>
                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Meta Title</Typography>
                        <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.title ? singleLegal?.metaProperties?.title : "-"}</Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                        <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.description ? singleLegal?.metaProperties?.description : "-"}</Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Updated By</Typography>
                        <Typography variant='h5' fontWeight="medium">{singleLegal?.createdBy ? singleLegal?.createdBy : "-"}</Typography>
                      </Grid>

                    </Grid>
                  </Card>

                  {/***************** Top Banner ****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">Header Section</Typography>
                      <StatusText status={singleLegal?.headerSection?.status ? "active" : "inactive"} />
                    </Stack>
                    {
                      singleLegal?.headerSection?.status &&
                      <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={6}>
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <Typography variant='body2' color={grey[600]} mb={1}>Title(H1)</Typography>
                              <Typography variant='h5' fontWeight="medium">{singleLegal?.headerSection?.pageTitle ? singleLegal?.headerSection?.pageTitle : "-"}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                              <Typography
                                variant="h5"
                                fontWeight="medium"
                                dangerouslySetInnerHTML={{
                                  __html: singleLegal?.headerSection?.section?.description || "-",
                                }}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <Typography variant='body2' color={grey[600]} mb={1}>Top Banner</Typography>
                              <Stack direction="row" spacing={1.25}>
                                <img style={{ borderRadius: '20px', width: '100%', height: '320px', objectFit: 'cover' }} src={singleLegal?.headerSection?.section?.image?.url ? singleLegal?.headerSection?.section?.image?.url : defaultProductImage} alt="No Image Found" />
                              </Stack>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    }

                  </Card>

                  {/***************** What You See Is What You Pay Section ****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">What You See Is What You Pay</Typography>
                      <StatusText status={singleLegal?.whatYouSeeSection?.status ? "active" : "inactive"} />

                    </Stack>

                    {/* Page Title */}
                    <Typography variant='h4' fontWeight="semibold" mb={3} textAlign="center">
                      {singleLegal?.whatYouSeeSection?.pageTitle || "-"}
                    </Typography>

                    {/* Section Cards */}
                    <Grid container spacing={2} mb={4}>
                      {singleLegal?.whatYouSeeSection?.section?.map((item) => (
                        <Grid item xs={12} sm={6} key={item._id}>
                          <Card sx={{
                            p: 2.5,
                            textAlign: 'left',
                            height: '100%',
                            borderRadius: 2,
                            border: '1px solid #ededed',
                            boxShadow: 'none',
                          }}>
                            <Stack spacing={1.5} direction="row" alignItems="center">
                              {/* Icon/Image */}
                              <Box
                                sx={{
                                  width: 48,
                                  height: 48,
                                  borderRadius: '12px',
                                  backgroundColor: '#FFD700',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  mb: 1
                                }}
                              >
                                <Box
                                  component="img"
                                  src={item.image?.url || defaultProductImage}
                                  alt={item.image?.alt || item.title}
                                  sx={{
                                    width: 24,
                                    height: 24,
                                    objectFit: 'contain'
                                  }}
                                />
                              </Box>

                              {/* Content */}
                              <Box flex={1}>
                                <Typography variant='body1' fontWeight="600" sx={{ fontSize: '0.95rem', lineHeight: 1.3, mb: 0.5 }}>
                                  {item.title}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color={grey[700]}
                                  sx={{ fontSize: '0.875rem', lineHeight: 1.4 }}
                                  dangerouslySetInnerHTML={{
                                    __html: item.description || "",
                                  }}
                                />
                              </Box>
                            </Stack>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>

                    {/* Bottom Description Banner */}
                    <Box
                      sx={{
                        p: 2.5,
                        backgroundColor: '#fff2cb',
                        borderRadius: 1.5,
                        textAlign: 'center',
                        border: '1px solid #ffd100'
                      }}
                    >
                      <Typography variant='body1' fontWeight="500" sx={{ fontSize: '1rem', lineHeight: 1.4 }} style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 31 31" fill="none">
                          <path d="M15.5002 28.4167C22.6338 28.4167 28.4168 22.6337 28.4168 15.5C28.4168 8.36636 22.6338 2.58337 15.5002 2.58337C8.36648 2.58337 2.5835 8.36636 2.5835 15.5C2.5835 22.6337 8.36648 28.4167 15.5002 28.4167Z" stroke="#D4A10C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                          <path d="M11.625 15.5L14.2083 18.0833L19.375 12.9166" stroke="#D4A10C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                        {singleLegal?.whatYouSeeSection?.bottomDescription || "-"}
                      </Typography>
                    </Box>
                  </Card>

                  {/***************** What Makes Up Your Total Section ****************/}
                  {singleLegal?.makesUpYourTotalSection?.status &&
                    <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                        <Typography variant='h5' fontWeight="semibold">What Makes Up Your Total</Typography>
                        <StatusText status={singleLegal?.makesUpYourTotalSection?.status ? "active" : "inactive"} />
                      </Stack>
                      
                      {/* Page Title */}
                      <Typography variant='h4' fontWeight="semibold" mb={3}>
                        {singleLegal?.makesUpYourTotalSection?.pageTitle || "-"}
                      </Typography>
                      
                      {/* Section Items */}
                      <Stack spacing={3}>
                        {singleLegal?.makesUpYourTotalSection?.section?.map((item) => (
                          <Stack key={item._id} direction="column" spacing={1} alignItems="start">
                            <Box display="flex" flexDirection="row" gap={2}>
                              {/* Icon/Image */}
                              <Box
                                component="img"
                                src={item.image?.url || defaultProductImage}
                                alt={item.image?.alt || item.title}
                                sx={{
                                  width: 24,
                                  height: 24,
                                  objectFit: 'contain',
                                  flexShrink: 0
                                }}
                              />
                              <Typography variant='h6' fontWeight="600">
                                {item.title}
                              </Typography>
                            </Box>
                            
                            {/* Content */}
                            <Box flex={1}>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.description || "",
                                }}
                              />
                            </Box>
                          </Stack>
                        ))}
                      </Stack>
                    </Card>
                  }

                  {/***************** Fees and Policies Section ****************/}
                  {singleLegal?.feesPoliciesSection?.status &&
                    <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                        <Typography variant='h5' fontWeight="semibold">Fees and Policies</Typography>
                        <StatusText status={singleLegal?.feesPoliciesSection?.status ? "active" : "inactive"} />
                      </Stack>
                      
                      {/* Page Title */}
                      <Typography variant='h4' fontWeight="semibold" mb={3}>
                        {singleLegal?.feesPoliciesSection?.pageTitle || "-"}
                      </Typography>
                      
                      {/* Policy Items */}
                      <Stack spacing={3}>
                        {singleLegal?.feesPoliciesSection?.section?.map((item) => (
                          <Stack key={item._id} direction="column" spacing={1} alignItems="start">
                            <Box display="flex" flexDirection="row" gap={2}>
                              {/* Icon/Image */}
                              <Box
                                component="img"
                                src={item.image?.url || defaultProductImage}
                                alt={item.image?.alt || item.title}
                                sx={{
                                  width: 24,
                                  height: 24,
                                  objectFit: 'contain',
                                  flexShrink: 0
                                }}
                              />
                              <Typography variant='h6' fontWeight="600">
                                {item.title}
                              </Typography>
                            </Box>
                            
                            {/* Content */}
                            <Box flex={1}>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.description || "",
                                }}
                              />
                            </Box>
                          </Stack>
                        ))}
                      </Stack>
                    </Card>
                  }
                      {/* taxesSection */}

                  {/***************** Taxes Section ****************/}
                  {singleLegal?.taxesSection?.status &&
                    <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                        <Typography variant='h5' fontWeight="semibold">Taxes</Typography>
                        <StatusText status={singleLegal?.taxesSection?.status ? "active" : "inactive"} />
                      </Stack>
                      
                      {/* Page Title */}
                      <Typography variant='h4' fontWeight="semibold" mb={1}>
                        {singleLegal?.taxesSection?.pageTitle || "-"}
                      </Typography>
                      
                      {/* Description */}
                      <Typography variant="body2" color={grey[600]} mb={3}>
                        {singleLegal?.taxesSection?.description || "-"}
                      </Typography>
                      
                      {/* Section Items */}
                      <Stack spacing={2} mb={3}>
                        {singleLegal?.taxesSection?.section?.map((item) => (
                          <Card key={item._id} sx={{ 
                            p: 2.5,
                            borderRadius: 2,
                            backgroundColor: "#f9f9f9",
                            boxShadow: 'none',
                          }}>
                            <Stack direction="row" spacing={2} alignItems="center">
                              {/* Icon/Image */}
                              <Box
                                sx={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: '10px',
                                  backgroundColor: '#ededed',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  flexShrink: 0
                                }}
                              >
                                <Box
                                  component="img"
                                  src={item.image?.url || defaultProductImage}
                                  alt={item.image?.alt || item.title}
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    objectFit: 'contain'
                                  }}
                                />
                              </Box>
                              
                              {/* Content */}
                              <Box flex={1}>
                                <Typography variant='h6' fontWeight="600" mb={0.5}>
                                  {item.title}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color={grey[600]}
                                  dangerouslySetInnerHTML={{
                                    __html: item.description || "",
                                  }}
                                />
                              </Box>
                            </Stack>
                          </Card>
                        ))}
                      </Stack>

                      {/* Bottom Description (Pro Tip) */}
                      {singleLegal?.taxesSection?.bottomDescription &&
                        <Card sx={{
                          p: 2.5,
                          borderRadius: 2,
                          backgroundColor: '#fff2cb',
                          border: '1px solid #ffd100',
                          boxShadow: 'none',
                          textAlign: 'center'
                        }}>
                          <Typography variant="body2" color={grey[800]} fontWeight="500">
                            <span style={{ color: "#d4a10c" }}>Pro Tip:</span> {singleLegal?.taxesSection?.bottomDescription}
                          </Typography>
                        </Card>
                      }
                    </Card>
                  }

                  {/***************** FAQ **************** */}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">FAQs</Typography>
                      <StatusText status={singleLegal?.faq?.status ? "active" : "inactive"} />
                    </Stack>
                    {
                      singleLegal?.faq?.status && <>
                        {
                          singleLegal?.faq?.section?.length !== 0 ?

                            <Grid container alignItems="center">
                              {
                                singleLegal?.faq?.section?.map((data) => {
                                  return (
                                    <Grid item xs={12} mb={2} key={data.answer}>
                                      <Typography
                                        variant="h5"
                                        fontWeight="medium"
                                        dangerouslySetInnerHTML={{
                                          __html: data?.question || "-",
                                        }}
                                      />
                                      <Typography
                                        variant="body2"
                                        color={grey[600]}
                                        dangerouslySetInnerHTML={{
                                          __html: data?.answer || "-",
                                        }}
                                      />
                                    </Grid>
                                  )
                                })
                              }
                            </Grid>
                            : <NoDataFound />
                        }
                      </>
                    }
                  </Card>
                </Box>
            }
          </>
      }
    </>
  )
}

export default PricingDetail